<template>
  <Transition name="fade">
    <div
      v-if="qualificationFunction('showLoginedPanel')"
      class="mobile_logined_account"
    >
      <div class="mobile_logined_account_inner" :class="{opacity : showModal.isSuccess}">
        <img
          class="side_logo" :src="getLevelImageSrc(accessedMemberInfo.level,'SideLogo')"
          alt="side logo"
        >
        <img
          class="character"
          :src="getLevelImageSrc(accessedMemberInfo.level,'')"
          :alt="`${accessedMemberInfo.level}`"
        >
        <h2 class="character_name" :class="getLevelName()">
          {{ getLevelName() }}
        </h2>
        <h3 class="setellite_name">
          OREUM-SAT
        </h3>
        <TransitionGroup
          name="fade" tag="div"
          class="contents"
        >
          <AccountInfo v-if="!showPanel.isEditPassword" />
          <EditPassword v-else />
        </TransitionGroup>
        <IconButtons :class="{'mobile_account_btn' : accessedMemberInfo.name}" />
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';

import AccountInfo from '@/components/common/AccountInfo.vue';
import EditPassword from '@/components/common/EditPassword.vue';
import IconButtons from '@/components/mobile/IconButtons.vue';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';

const { isImageMode } = storeToRefs(useCommonStore());
const { windowSize, showPanel, showModal } = useCommonStore();
const { accessedMemberInfo, getLevelImageSrc, getLevelName } = useMemberStore();

/**
 * 조건별 함수
 */
const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showLoginedPanel':
      return !!(showPanel.isMobileAccountInfo && accessedMemberInfo.name && !isImageMode.value && windowSize.width < windowSize.height);
    default:
      return false;
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.layout {
  .mobile_logined_account {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 1;

    .fade-enter-active {
      transition: all 0.3s ease-out;
      transition-delay: 0.3s;
    }

    .fade-leave-active {
      transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    &_inner {
      min-height: 500px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .side_logo {
        width: 216px;
        margin-bottom: 20px;
      }

      .character {
        width: 190.8px;
        margin-bottom: 10px;
      }

      .character_name {
        font-family: "Montserrat black 900", sans-serif;
        color: $color-black;
        padding: 1.9px 12.7px;
        background: $color-mete;
        border-radius: 50px;
        margin-bottom: 7px;

        &.DEBRA {
          background: $color-debra;
        }

        &.METE {
          background: $color-mete;
        }

        &.KORONG {
          background: $color-korong;
        }
      }

      .setellite_name {
        font-family: "Poppins ExtraBold 900", sans-serif;
        color: $color-white;
        font-size: 25px;
        margin-bottom: 10%;
      }

      .icon_buttons {
        bottom: 0;

        &.mobile_account_btn {
          gap: 15px;
        }
      }
    }
  }
}

// mobile 세로 모드
@media screen and (min-width: 250px) and (max-width: 499px) and (min-height: 450px) {
  .layout {
    .mobile_logined_account {
      &_inner {
        width: 100%;
        top: 5%;
        transform: translate(-50%, 0);
        height: 95%;


        .side_logo {
          width: 60%;
        }

        .character {
          width: 40%;
        }

        .setellite_name {
          font-size: 1.4rem;
          margin-bottom: 15px;
        }

        .icon_buttons {
          bottom: 0;
          padding-bottom: 20px;
        }

        .contents {
          width: 190px;
        }

        &.opacity {
          opacity: 0.3;
        }
      }
    }
  }
}

// tablet
@media screen and (min-width: 500px) and (min-height: 500px) {
  .mobile_logined_account {
    overflow: auto;

    &_inner {
      height: 100%;
      min-height: 780px;
      transform: translate(-50%, 0);

      .side_logo {
        margin-top: 100px;
      }

      .contents {
        width: 190px;
      }
    }
  }
}

// mobile 세로 모드 Gallaxy Fold
@media screen and (min-width: 512px) and (max-height: 718px) and (-webkit-min-device-pixel-ratio: 1.5) {
  .layout {
    .mobile_logined_account {
      &_inner {
        .side_logo {
          width: 55%;
          margin-top: 40px;
        }

        .character {
          width: 40%;
        }
      }
    }
  }
}

// Surface Duo
@media screen and (min-width: 540px) and (max-height: 720px) and (-webkit-min-device-pixel-ratio: 1.5) {
  .layout {
    .mobile_logined_account {
      &_inner {
        min-height: 0;

        .side_logo {
          margin-top: 30px;
        }
      }
    }
  }
}
</style>